import { instance } from './config';
import { types as rs } from './types';


export const postOrder = (data: rs.Order) => {
  return instance.post(`/api/shop/${data.shop_id}/order`, data);
};
